import { QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation, useQuery } from '@tanstack/react-query';

/**
 * 1481. 見積タスクコメント欄に見積内容を記載して申請更新
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_amount_from_mf
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  enabled?: boolean;
};

const quotationAmountFromMf = (props: Props): Promise<{ amount: number }> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.id}/quotation_amount_from_mf`,
    { params: props }
  );
};

export const useQuotationAmountFromMf = (props: Props) => {
  return useQuery({
    queryKey: [{ ...props }],
    queryFn: () => quotationAmountFromMf(props),
    enabled: props.enabled,
  });
};
